/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_WarningInputs */

const en_gc_resources_download_warning = /** @type {(inputs: Gc_Resources_Download_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha software: save before closing, keep backups and check important formulas after importing.`)
};

const zh_gc_resources_download_warning = /** @type {(inputs: Gc_Resources_Download_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha 版本：关闭前请保存，保留备份，并在导入后检查重要公式。`)
};

/**
* | output |
* | --- |
* | "Alpha software: save before closing, keep backups and check important formulas after importing." |
*
* @param {Gc_Resources_Download_WarningInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_warning = /** @type {((inputs?: Gc_Resources_Download_WarningInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_WarningInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_warning(inputs)
	return zh_gc_resources_download_warning(inputs)
});
export { gc_resources_download_warning as "gc.resources.download.warning" }